/** @jsx jsx */
import React from 'react';

import styled from '@emotion/styled';
import { Interpolation, jsx, Theme } from '@emotion/react';
import { ModuleComponents } from '../../components/ModuleComponents';
import { Link } from 'react-router-dom';

interface AnchorPropsStyled {
    to: string;
}

interface AnchorProps extends AnchorPropsStyled {
    css?: Interpolation<Theme>;
    components?: any;
}

export const Anchor: React.FC<AnchorProps> = ({
    children,
    components,
    to,
    ...props
}) => {
    return (
        <StyledAnchor to={to} {...props}>
            {components && <ModuleComponents components={components} />}
            {children}
        </StyledAnchor>
    );
};

const StyledAnchor = styled(Link)<AnchorPropsStyled>`
    text-decoration: none;
    cursor: pointer;
    display: block;
`;
